import { Button, Form, Input } from "antd";
import TextArea from "antd/es/input/TextArea";
import EditIcon from "../../../assets/icons/EditIcon";
import InfoItemTwo from "../../../components/common/sidebar/InfoItemTwo";
import EmployeeFileUpload from "../../../components/Employees/EmployeeFileUpload";
import SidebarLayout from "../../../layouts/SidebarLayout";

export default function Home() {
  const [form] = Form.useForm();
  const onFinish = (values: any) => {};
  return (
    <SidebarLayout title="Website CMS-Home">
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        <div className="grid md:grid-cols-520 gap-6">
          <div className="bg-white border border-extra-light p-6 max-w-[712px] rounded-md">
            <div
              className={`bg-[#F0F3F9] flex justify-between items-center border-b px-3 py-2.5 border-[#8897AE] font-medium rounded-t-md`}
            >
              <h4 className="text-display-body ">Button/CTA Title</h4>

              <div className="text-display-body ">Action</div>
            </div>
            <InfoItemTwo
              title="Try it free"
              children={
                <span className="text-[#4A72FF]">
                  <EditIcon />
                </span>
              }
            />
            <InfoItemTwo
              title="Schedule a demo"
              children={
                <span className="text-[#4A72FF]">
                  <EditIcon />
                </span>
              }
            />

            <Form.Item
              name=""
              label="Video Link"
              className="my-4 "
              rules={[
                {
                  required: true,
                  message: "Please enter contact",
                },
              ]}
            >
              <Input
                prefix="https://"
                placeholder="www.youtube.com/sheba_xyz"
              />
            </Form.Item>

            <Form.Item
              name="nid_image_front"
              label="Trusted By 1000+ Businesses in Bangladesh"
              className="my-4 "
              valuePropName="fileUrl"
              rules={[
                {
                  required: true,
                  message: "Please upload NID photo",
                },
              ]}
            >
              <EmployeeFileUpload
                form={form}
                accept=".png, .jpg, .jpeg"
                name="nid_image_front"
                // onChange={(url) =>
                //   form.setFieldsValue({
                //     nid_image_front: url,
                //   })
                // }
              />
            </Form.Item>

            <div
              className={`bg-[#F0F3F9]   px-3 py-2.5 font-medium rounded-t-md`}
            >
              <h4 className="text-display-body ">Stories Section</h4>
            </div>

            <Form.Item
              name="nid_image_front"
              label="Image"
              className="my-4 "
              valuePropName="fileUrl"
              rules={[
                {
                  required: true,
                  message: "Please upload NID photo",
                },
              ]}
            >
              <EmployeeFileUpload
                form={form}
                accept=".png, .jpg, .jpeg"
                name="nid_image_front"
                // onChange={(url) =>
                //   form.setFieldsValue({
                //     nid_image_front: url,
                //   })
                // }
              />
            </Form.Item>

            <Form.Item
              name="nid_image_front"
              label="Section Title"
              className="my-4 "
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <Input placeholder="Stories You Would Want To Know" />
            </Form.Item>

            <Form.Item
              name="nid_image_front"
              label="Short Description"
              className="my-4 "
              rules={[
                {
                  required: true,
                  message: "Please enter title",
                },
              ]}
            >
              <TextArea rows={5} placeholder="Enter a description..." />
            </Form.Item>

            <div
              className={`bg-[#F0F3F9]   px-3 py-2.5 font-medium rounded-t-md`}
            >
              <h4 className="text-display-body ">We are on New Section</h4>
            </div>
            <div className="grid grid-cols-2 gap-x-2.5 ">
              <Form.Item
                name="thumbnail"
                label="Thumbnail"
                className="mt-4 "
                valuePropName="fileUrl"
                rules={[
                  {
                    required: true,
                    message: "Please upload NID photo",
                  },
                ]}
              >
                <EmployeeFileUpload
                  form={form}
                  accept=".png, .jpg, .jpeg"
                  name="thumbnail"
                  // onChange={(url) =>
                  //   form.setFieldsValue({
                  //     nid_image_front: url,
                  //   })
                  // }
                />
              </Form.Item>
              <Form.Item
                name="link"
                label="News Link"
                className="mt-4 "
                rules={[
                  {
                    required: true,
                    message: "Please enter title",
                  },
                ]}
              >
                <Input prefix="https://" placeholder="www.news/sheba_xyz" />
              </Form.Item>
              {/*  */}
              <Form.Item
                name="thumbnail"
                label="Thumbnail"
                className=""
                valuePropName="fileUrl"
                rules={[
                  {
                    required: true,
                    message: "Please upload NID photo",
                  },
                ]}
              >
                <EmployeeFileUpload
                  form={form}
                  accept=".png, .jpg, .jpeg"
                  name="thumbnail"
                  // onChange={(url) =>
                  //   form.setFieldsValue({
                  //     nid_image_front: url,
                  //   })
                  // }
                />
              </Form.Item>
              <Form.Item
                name="link"
                label="News Link"
                className=""
                rules={[
                  {
                    required: true,
                    message: "Please enter title",
                  },
                ]}
              >
                <Input prefix="https://" placeholder="www.news/sheba_xyz" />
              </Form.Item>
              {/*  */}
              <Form.Item
                name="thumbnail"
                label="Thumbnail"
                className=""
                valuePropName="fileUrl"
                rules={[
                  {
                    required: true,
                    message: "Please upload NID photo",
                  },
                ]}
              >
                <EmployeeFileUpload
                  form={form}
                  accept=".png, .jpg, .jpeg"
                  name="thumbnail"
                  // onChange={(url) =>
                  //   form.setFieldsValue({
                  //     nid_image_front: url,
                  //   })
                  // }
                />
              </Form.Item>
              <Form.Item
                name="link"
                label="News Link"
                className=""
                rules={[
                  {
                    required: true,
                    message: "Please enter title",
                  },
                ]}
              >
                <Input prefix="https://" placeholder="www.news/sheba_xyz" />
              </Form.Item>
              {/*  */}
              <Form.Item
                name="thumbnail"
                label="Thumbnail"
                className=""
                valuePropName="fileUrl"
                rules={[
                  {
                    required: true,
                    message: "Please upload NID photo",
                  },
                ]}
              >
                <EmployeeFileUpload
                  form={form}
                  accept=".png, .jpg, .jpeg"
                  name="thumbnail"
                  // onChange={(url) =>
                  //   form.setFieldsValue({
                  //     nid_image_front: url,
                  //   })
                  // }
                />
              </Form.Item>
              <Form.Item
                name="link"
                label="News Link"
                className=""
                rules={[
                  {
                    required: true,
                    message: "Please enter title",
                  },
                ]}
              >
                <Input prefix="https://" placeholder="www.news/sheba_xyz" />
              </Form.Item>
            </div>

            <Button className="middle-button mt-6" type="primary">
              Update
            </Button>
          </div>
        </div>
      </Form>
    </SidebarLayout>
  );
}
